import { generateBaseQueryKeysList } from '@/queries/utils';

export const TX_CENTER_PROVIDERS_KEYS = {
  main: 'txcenter-providers',
};

export const txCenterProvidersQueryKeys = generateBaseQueryKeysList(TX_CENTER_PROVIDERS_KEYS.main);
